import React from 'react';

const OurServicesPage = () => {
    return (
        <>
  <section
    className="our-services text-center text-white"
    style={{ backgroundImage: "url(assets/img/our-services.png)" }}
  >
    <div className="container-lg inner-container position-relative">
      <h6>Our Services</h6>
      <h1>Growth Oriented B2B Marketing Services </h1>
      <h2>Relax. We’ve got this.</h2>
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <p>
            <b>Congrats, you’ve found us! </b>
            <br /> Now grab a seat and get comfy, because you’re gonna love what
            we’re about to tell you
          </p>
        </div>
      </div>
    </div>
  </section>
  <section className="bg-010102 top-places">
    <i
      className="top-places-shape"
      style={{ backgroundImage: "url(assets/img/our-services-top-places.png)" }}
    />
    <div className="container-lg inner-container position-relative text-white">
      <div className="row">
        <div className="col-xl-6 col-md-6 pe-lg-5">
          <div className="pe-lg-5">
            <h2>
              Your pipeline is about to{" "}
              <span className="c-F0B2FF">explode</span>.
            </h2>
            <p className="pe-md-4">
              Because at <b>Purplepatch</b>, we’re in the business of making
              your business grow. We nerd out on crafting high-quality content
              that builds trust in your prospects. We dive into engaging
              conversations across every channel, making sure your message is
              heard and considered. And we actively seek out and identify
              opportunities to enable faster conversions.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="our-servicesban-btm">
    <div className="container-lg inner-container position-relative  ">
      <h2>
        <span className="c-primary1">B2B marketing services</span> for your
        business
      </h2>
      <p>
        Navigating the complexities of B2B buying processes and decision cycles
        can be challenging. At Purplepatch, we understand these challenges and
        specialize in transforming them into opportunities. Our data-driven
        approach provides real-time insights into your prospects' buying
        intentions, allowing for more relevant and impactful interactions. By
        focusing on your prospects' preferences and needs, we empower your sales
        teams to align closely with their vision, accelerating the discovery of
        new opportunities and fostering meaningful connections.
      </p>
      <h3>
        Customized <span className="c-primary1">B2B Marketing Services</span>
      </h3>
      <p className="mb-0">
        We are dedicated to delivering solutions that directly address the pain
        points of our B2B clients. Our services are not just about marketing;
        they're about creating connections, understanding customer needs, and
        driving growth. From personalized account-based marketing to
        comprehensive SEO strategies, each service is tailored to solve specific
        challenges and deliver tangible benefits to your business.
      </p>
    </div>
  </section>
  <section className="seo-accordion accordion-style">
    <div className="container-lg inner-container position-relative text-white">
      <div className="accordion" id="ac1">
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Account-Based Marketing
            </button>
          </h5>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body pe-0 accordion-divide-set">
              <div className="row cl3 justify-content-between">
                <div className="col-xl-3 col-lg-4 col-md-6">
                  <div className="acc-bx-icon icon-list-2 acc-df-icon"></div>
                  <h5>Target Account Identification:</h5>
                  <p>
                    {" "}
                    We cut through the noise to identify the accounts that
                    matter most to your business, saving you time and resources
                    while increasing the likelihood of success.
                  </p>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  <div className="acc-bx-icon icon-list-2 acc-df-icon"></div>
                  <h5>Personalized Content Creation:</h5>
                  Our content is crafted to speak directly to your target
                  accounts, addressing their unique needs and challenges,
                  fostering engagement and building trust.
                  <p />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  <div className="acc-bx-icon icon-list-2 acc-df-icon"></div>
                  <h5>ABM Campaign Execution:</h5>
                  We launch campaigns that resonate with each account, ensuring
                  that your message is not only heard but also acts as a
                  solution to their specific problems.
                  <p />
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                  <div className="acc-bx-icon icon-list-2 acc-df-icon"></div>
                  <h5>Account-Based Analytics:</h5>
                  <p>
                    Our analytics provide clear insights into campaign
                    performance, allowing for agile adjustments and ensuring
                    that your efforts are always aligned with account needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Content Marketing
            </button>
          </h5>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                2B SEO services involve optimizing a business's online presence
                to improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Lead Generation
            </button>
          </h5>
          <div
            id="collapseThree"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                B SEO services involve optimizing a business's online presence
                to improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsefour"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Website Design and Development
            </button>
          </h5>
          <div
            id="collapsefour"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsefive"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Search Engine Optimization (SEO)
            </button>
          </h5>
          <div
            id="collapsefive"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsesix"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Social Media Marketing
            </button>
          </h5>
          <div
            id="collapsesix"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseseven"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Email Marketing
            </button>
          </h5>
          <div
            id="collapseseven"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseeight"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Paid Advertising
            </button>
          </h5>
          <div
            id="collapseeight"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsenine"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Marketing Automation
            </button>
          </h5>
          <div
            id="collapsenine"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseten"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Program Management
            </button>
          </h5>
          <div
            id="collapseten"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section
    className="bg-black text-white innovative-marketing"
    style={{ backgroundImage: "url(assets/img/innovative-marketing.png)" }}
  >
    <div className="container-lg inner-container">
      <div className="row">
        <div className="col-xl-6">
          <h3>
            Our Innovative{" "}
            <span className="c-FDB3D4">B2B Marketing Process</span>
          </h3>
          <p>
            At the heart of our approach is a deep understanding of today's
            digital-first marketplace. We blend our love for storytelling with
            the latest in technology and insightful market analysis to keep you
            a step ahead. We're focused on delivering results that matter, using
            creative but data-driven strategies that are as unique as your
            business.{" "}
          </p>
        </div>
      </div>
    </div>
    <div className="plset ui-pt-res-100">
      <div className="owl-carousel owl-milestone milestone-point">
        <div className="item num-1">
          <span className="m-num">01</span>
          <p>Market Analysis and Insight Gathering</p>
        </div>
        <div className="item num-2">
          <span className="m-num">02</span>
          <p>Target Audience Segmentation</p>
        </div>
        <div className="item num-3">
          <span className="m-num">03</span>
          <p>Customized Strategy Development</p>
        </div>
        <div className="item num-4">
          <span className="m-num">04</span>
          <p>Content Creation and Multi-Channel Distribution</p>
        </div>
        <div className="item num-5">
          <span className="m-num">05</span>
          <p>Performance Monitoring and Analytics</p>
        </div>
        <div className="item num-6">
          <span className="m-num">06</span>
          <p>Feedback Integration and Process Optimization</p>
        </div>
      </div>
    </div>
  </section>
  <section
    className="get-form-touch"
    style={{ backgroundImage: "url(assets/img/get-form-touch.png)" }}
  >
    <div className="container-lg inner-container">
      <div className="row">
        <div className="col-md-6 text-white">
          <h5 className="ss-1">Contact</h5>
          <h4 className="ss-2">
            Ready to start your growth with Our B2B Digital Marketing Service?
          </h4>
          <div className="home-feat-article">
            <div className="dflex-1 text-black">
              <div className="dflex-1-cnt">
                <h6>Featured Article</h6>
                <h5>What is good conversion rate?</h5>
              </div>
              <div className="dflex-1-icon">
                <img src="assets/img/peop-1.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 text-white">
          <h6 className="ss-3">
            Your success story begins here. Connect with us today!
          </h6>
          <p>
            Are you ready to start elevating your brand and getting results?
            Then stop reading and start typing! Fill out the form and let’s
            begin…
          </p>
        </div>
      </div>
    </div>
  </section>
</>

    );
};

export default OurServicesPage;
